import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../apiClient';
import CompanyTable from '../../Component/company/CompanyTable';
import Header from '../../Component/common/Header/Header';
import SearchBar from '../../Component/common/SearchBar/SearchBar';

const CompanyPage = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await apiClient.get('/api/contacts/company');
        if (response.data) {
          setCompanies(response.data);
        } else {
          setError('No data received from server');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch companies');
        console.error('API Error:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  const filteredCompanies = companies.filter(company =>
    company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.phone?.includes(searchTerm)
  );

  return (
    <div className="company-page-container">
      <Header
        title="Company Contacts"
        onAddAction={() => navigate('/contacts/company/new')}
      />
      
      <div className="company-controls">
        <SearchBar
          placeholder="Search companies..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {isLoading ? (
        <div className="loading">Loading contacts...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <div className="contacts-list">
          {filteredCompanies.length > 0 ? (
            <CompanyTable
              companies={filteredCompanies}
            />
          ) : (
            <div className="no-contacts">
              {searchTerm ? 'No matching companies found' : 'No companies available'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanyPage;
